import React from 'react';
import NumberFormat from 'react-number-format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

import BasicControlGroup from 'components/BasicControlGroup';

import './styles.css';

const FirmStrategyFundItem = props => {
  const {
    item: {
      FirmFundHistoryID,
      FundName,
      FundNumber,
      FundNumberType,
      Vintage,
      FirmFundFocus,
      Geography,
      Returns,
      disabled = false,
    },
    editMode,
    onEditClick,
    onDeleteClick,
  } = props;

  const handleEditClick = () => {
    !disabled && onEditClick(FirmFundHistoryID);
  };

  const handleDeleteClick = () => {
    !disabled && onDeleteClick({ FirmFundHistoryID, FundName });
  };

  return (
    <div className="firm-strategy-fund-item">
      <div className="firm-strategy-fund-item__top">
        <div
          className="firm-strategy-fund-item__caption"
          style={{ flex: '1 1 auto' }}
        >
          {FundName}
        </div>
        {editMode && (
          <BasicControlGroup
            groupStyles={{
              marginLeft: '20px',
              flex: '0 1 auto',
              minWidth: '50px',
            }}
          >
            <div
              className="firm-strategy-fund-item__control"
              style={{
                marginRight: 0,
              }}
              onClick={handleEditClick}
            >
              <FontAwesomeIcon icon={faEdit} size="1x" />
            </div>

            <div
              className="firm-strategy-fund-item__control"
              onClick={handleDeleteClick}
              style={{
                marginRight: 0,
              }}
            >
              <FontAwesomeIcon icon={faTrash} size="1x" />
            </div>
          </BasicControlGroup>
        )}
      </div>

      <div className="firm-strategy-fund-item__size">
        <div className="firm-strategy-fund-item__number">
          <NumberFormat
            thousandSeparator
            value={Number(FundNumber)}
            displayType={'text'}
          />
        </div>
        <div className="firm-strategy-fund-item__type">{FundNumberType}</div>
      </div>
      <div className="firm-strategy-fund-item__vintage">
        <span className="firm-strategy-fund-item__property">Vintage:</span>{' '}
        {Vintage}
      </div>
      <div className="firm-strategy-fund-item__focus">
        <span className="firm-strategy-fund-item__property">Focus:</span>{' '}
        {FirmFundFocus}
      </div>
      <div className="firm-strategy-fund-item__geography">
        <span className="firm-strategy-fund-item__property">Geography: </span>
        {Geography}
      </div>
      {Returns && (
        <div className="firm-strategy-fund-item__returns">
          <span className="firm-strategy-fund-item__property">Returns: </span>
          {Returns}
        </div>
      )}
    </div>
  );
};

export default FirmStrategyFundItem;
